import { FC } from 'react'
import styled, { StyledProps } from 'styled-components'
import { Box } from '@ucheba/ui/components/Box/touch'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import GraduationCapIcon from '@ucheba/ui/icons/icon__graduation-cap.svg'
import GraduationCapCheckIcon from '@ucheba/ui/icons/icon__graduation-cap-check.svg'
import RestartIcon from '@ucheba/ui/icons/icon__restart.svg'
import { useSelector } from 'react-redux'
import { probabilitiesSelectors } from '@ucheba/store/probabilities'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import {
  EAssessmentColorBg,
  EAssessmentColorText,
  EAssessmentText,
  IOddsAssessmentResults,
} from '../types'
import { useOddsAssessmentResultsCore } from '../bll'
import { useProgramsOfficialRepresentative } from '../../../../../pages/program/ssr/[id]/index/bll/useProgramsOfficialRepresentative'
import ProgramList from '../../../../ProgramList/desktop'

const Block = styled.div``

const BoxST = styled<StyledProps<any>>(Box)`
  border-radius: 8px 8px 0 0;
`

const BoxDefault = styled(Box)`
  background-color: ${sv.color.silver};
`

const OddsAssessmentResults: FC<IOddsAssessmentResults> = (props) => {
  const {
    institutionsName,
    programName,
    programId,
    programIds,
    probability,
    onReset,
    onClose,
  } = props

  const { hasInPlan, isLoading } = useOddsAssessmentResultsCore(programId, programIds)

  const anotherPrograms = useSelector(probabilitiesSelectors.anotherPrograms)

  const { onOpen } = useProgramsOfficialRepresentative()

  if (!probability) {
    return (
      <Block>
        <BoxDefault color='silver' spacing='large'>
          <Heading h2='Ждём ваши шансы на поступление' color='gray60' spacing='xxsmall' />

          <Text color='gray50'>{institutionsName}</Text>

          <Spacing spacing='usmall' />

          <Text fontSize='h3' lineHeight='h3' fontWeight='bold' color='gray50'>
            {programName}
          </Text>
        </BoxDefault>
      </Block>
    )
  }

  return (
    <Block>
      <BoxST
        color={EAssessmentColorBg[probability]}
        spacing='xlarge'
        radius={anotherPrograms && anotherPrograms.length > 0 ? 'small' : 'null'}
      >
        <Heading
          h2={`У вас ${EAssessmentText[probability]} шансы поступить`}
          color={EAssessmentColorText[probability]}
          spacing='xxsmall'
        />

        <Text color={EAssessmentColorText[probability]}>{institutionsName}</Text>

        <Spacing spacing='usmall' />

        <Text
          fontSize='h3'
          lineHeight='h3'
          fontWeight='bold'
          color={EAssessmentColorText[probability]}
        >
          {programName}
        </Text>

        <Spacing spacing='small' />

        <Grid spacing='xxsmall'>
          <GridCol width='auto'>
            {hasInPlan ? (
              <Button
                color={EAssessmentColorText[probability]}
                StartIcon={<GraduationCapCheckIcon />}
                view='outline'
                progress={isLoading}
                onClick={() => {
                  onDeleteProgram(programId)
                }}
              >
                В плане
              </Button>
            ) : (
              <Button
                color={EAssessmentColorText[probability]}
                StartIcon={<GraduationCapIcon />}
                progress={isLoading}
                onClick={() => {
                  onAddProgram(programId)
                }}
              >
                Хочу поступить
              </Button>
            )}
          </GridCol>

          <GridCol width='auto'>
            <Button
              color={EAssessmentColorText[probability]}
              onClick={() => {
                onClose()

                onOpen()
              }}
            >
              Задать вопрос
            </Button>
          </GridCol>

          <GridCol width='auto'>
            <div
              style={{
                marginLeft: '4px',
              }}
            >
              <Button
                color={EAssessmentColorText[probability]}
                EndIcon={<RestartIcon />}
                view='link'
                onClick={onReset}
              >
                Оценить шансы заново
              </Button>
            </div>
          </GridCol>
        </Grid>
      </BoxST>

      {anotherPrograms && anotherPrograms.length > 0 && (
        <Box spacing={['large', 'xlarge']}>
          <Heading h3='Другие программы' spacing='large' />

          <ProgramList
            items={anotherPrograms}
            showLogo={false}
            selectedIds={programIds}
            showButtons
          />
        </Box>
      )}
    </Block>
  )
}

export default OddsAssessmentResults
